import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { faCheckCircle, faPrint, faDownload } from '@fortawesome/free-solid-svg-icons';
import { PaymentResponse } from '../../../services/payjunction.service';

@Component({
  selector: 'app-payment-confirmation',
  templateUrl: './payment-confirmation.component.html',
  styleUrls: ['./payment-confirmation.component.css']
})
export class PaymentConfirmationComponent implements OnInit {
  faCheckCircle = faCheckCircle;
  faPrint = faPrint;
  faDownload = faDownload;

  @Input() paymentResult: PaymentResponse;
  @Input() paymentAmount: string;
  @Input() maskedCardNumber: string;

  currentDate: string;
  currentTime: string;

  constructor(public modal: NgbActiveModal) {}

  ngOnInit(): void {
    const now = new Date();
    this.currentDate = now.toLocaleDateString();
    this.currentTime = now.toLocaleTimeString();
  }

  printReceipt(): void {
    window.print();
  }

  downloadReceipt(): void {
    if (this.paymentResult.receiptUrl) {
      window.open(this.paymentResult.receiptUrl, '_blank');
    }
  }

  close(): void {
    this.modal.close('success');
  }
}